import { LoadingSpinner } from '../../components';
import { setIsUserIdle } from '../../redux/authenticatedUser/authenticatedUserReducer';
import { useTypedDispatch } from '../../redux/store';
import authRoutes from '../../routes/subRoutes/authRoutes';
import { handleSamlLoginResponse } from '../../services/samlLoginService';

const SamlReturnPage = () => {
    const dispatch = useTypedDispatch();

    const token = new URLSearchParams(window.location.search).get('token');

    const loginPath = authRoutes.find(route => route.key === 'login')?.path || '';

    if (token) {
        handleSamlLoginResponse(token).then((isSuccessful) => {
            if (isSuccessful) {
                dispatch(setIsUserIdle(false));
                window.location.href = `/${loginPath}`; // We use location.href to reset state
            } else {
                window.location.href = `/${loginPath}?saml-error=samlLoginFailure`; // We use location.href to reset state
            }
        });
    } else {
        console.error('SAML return page accessed without a token');
        window.location.href = `/${loginPath}?saml-error=samlLoginTokenMissing`; // We use location.href to reset state
    }

    return (
        <LoadingSpinner />
    );
};

export default SamlReturnPage;
